import React from 'react';

import FinishShiftCandidate from '../components/FinishShiftCandidate';
import LoadingView from '../components/LoadingView';

import HiringStore from '../stores/HiringStore';

import connectToStores from 'alt/utils/connectToStores';

import {getTotalCost, updateCandidatePay, getShiftDuration} from '../utils/shiftFees';

@connectToStores
class ShiftReport extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            totalCost: 0,
            ourFee: 0,
            candidatePay: [],
            candidateHours: []
        };
    }

    static getPropsFromStores() {
        return {
            hStore: HiringStore.getState()
        };
    }

    static getStores() {
        return [HiringStore];
    }

    getCandidates(candidates) {
        let hired_candidates = [];
        candidates.forEach((candidate, i) => {
            let hours = parseFloat(0).toFixed(2);
            if (!candidate.hiring.no_show && ['hired', 'cancelled by us'].indexOf(candidate.hiring.status) > -1) {
                hours = this.getCandidateHours(candidate);
            }
            hired_candidates.push(
                <FinishShiftCandidate index={i} hours={hours} updateCandidatePay={this.updateCandidatePay.bind(this)} candidate={candidate} disabled={true} />
            )
        });
        return hired_candidates;
    }

    updateCandidatePay(candidateId, pay, hours, index) {
        const candidates = this.props.candidates.filter(candidate => { return ['cancelled by us', 'hired'].indexOf(candidate.hiring.status) >= 0 && !candidate.hiring.no_show });
        const {candidatePay, candidateHours} = updateCandidatePay(candidateId, pay, hours, index, this.state.candidatePay, this.state.candidateHours);
        const {totalCost, ourFee} = getTotalCost(candidatePay, candidates.length);
        this.setState({candidatePay, candidateHours, totalCost, ourFee});
    }

    getCandidateHours(candidate) {
        const shift = this.props.shift;
        const reports = this.props.reports;

        if (Object.keys(reports).length && candidate.id && shift.status == 'finished') {
            const report = reports.filter(report => {return report.candidate === candidate.id})[0];
            if (report) {
                return parseFloat(report.hours).toFixed(2);
            } else if (['cancelled', 'cancelled by us'].indexOf(candidate.hiring.status) >= 0) {
                return parseFloat(0).toFixed(2);
            }
        }

        return getShiftDuration(shift);
    }

    render () {
        const candidates = this.props.candidates || {};
        const shift = this.props.shift;
        const reportsReceived = this.props.reportsReceived;
        let pdfButton;

        if (shift.status == 'finished') {
            const report_url = DJ_CONST.API_BASE + DJ_CONST.API.shiftReportPdf.replace('${pk}', shift.id);
            pdfButton = (
                <div className="report-right">
                    <a className="btn-download" href={report_url} target="_blank">Download timesheet</a>
                </div>
            );
        }

        if ((!Object.keys(candidates).length || !Object.keys(shift).length || !reportsReceived ) && shift.status != 'finished') {
            return (
                <div className={"shift-report " + (this.props.isActive ? "active" : "")}>
                    <LoadingView />
                </div>
            );
        }

        return (
            <div className={"shift-report " + (this.props.isActive ? "active" : "")}>

                <div className="report-box">
                    <div className="report-left">
                        <div className="report-item">
                            <h3 className="section-title">Total cost</h3>
                            <div className="report-number">{DJ_CONST.LOCALE_CONF.currency} {this.state.totalCost.toFixed(2)}</div>
                        </div>
                        <div className="report-item">
                            <h3 className="section-title">Workers</h3>
                            <div className="report-number">{candidates.length}</div>
                        </div>
                        <div className="report-item report-item-fee">
                            <h3 className="section-title">Our fee</h3>
                            <div className="report-number">{DJ_CONST.LOCALE_CONF.currency} {this.state.ourFee}</div>
                        </div>
                        <div className="report-item report-item-total">
                            <span>{DJ_CONST.LOCALE_CONF.currency} {DJ_CONST.OUR_FEE_COEFFICENT} per candidate</span>
                        </div>
                    </div>

                    {pdfButton}
                </div>
                <div className="table-wrapper">
                    {
                        (!Object.keys(candidates).length || !Object.keys(shift).length || !reportsReceived ) && shift.status == 'finished' ?
                            <div className="table worker-table">This shift had nobody hired.</div> :
                            <div className="table worker-table">
                                <div className="table-header">
                                    <div className="align-left">WORKER</div>
                                    <div>STATUS</div>
                                    <div>HOURLY RATE</div>
                                    <div>HOURS</div>
                                    <div>COST</div>
                                </div>
                                {this.getCandidates(candidates)}
                            </div>
                    }
                </div>

                <div className="buttons">
                    <div className="info-container">
                        {shift.status == DJ_CONST.SHIFT_STATUSES.FINISHED ? '' : <span className="info">You can edit the worked hours when finishing the shift.</span>}
                    </div>
                </div>
            </div>
        );
    }
}

export default ShiftReport;



/** WEBPACK FOOTER **
 ** ./app/src/components/ShiftReport.js
 **/